/** @jsx jsx */

/** @jsxFrag React.Fragment */
import { jsx } from '@emotion/react';

import * as React from 'react';

import { CardCreditType } from '@coursera/cds-core';

import { productCardDegreeOrCredit } from 'bundles/product-card/components/ProductCardDegreeOrCredit';
import isCreditOffered from 'bundles/search-common/components/search-cards/isCreditOffered';
import isPremiumProduct from 'bundles/search-common/components/search-cards/isPremiumProduct';
import { LEARNING_PRODUCTS } from 'bundles/search-common/constants';

type ProductType = (typeof LEARNING_PRODUCTS)[keyof typeof LEARNING_PRODUCTS];

type Props = {
  customBadge?: React.ReactNode;
  productType?: ProductType;
};

export const getCreditType = (productType?: ProductType): React.ComponentProps<typeof CardCreditType>['creditType'] => {
  return productCardDegreeOrCredit(productType === LEARNING_PRODUCTS.Degree);
};

export const shouldShowCreditBadge = (productType?: ProductType) => {
  const creditOffered = productType ? isCreditOffered(productType) : false;
  const premiumProduct = productType ? isPremiumProduct(productType) : false;
  const isDegree = productType === LEARNING_PRODUCTS.Degree;
  return premiumProduct && (isDegree || creditOffered);
};

const LearningProductCardBadge = ({ customBadge, productType }: Props) => {
  if (!customBadge && !productType) {
    return null;
  }

  if (customBadge) {
    return customBadge;
  } else if (shouldShowCreditBadge(productType)) {
    return <CardCreditType creditType={getCreditType(productType)} />;
  } else {
    return null;
  }
};

export default LearningProductCardBadge;
